import { procurementAPI } from "../../axios";

export const actions = {

    // DeliveryUnitItemCart
    GetDeliveryUnitItemCart(){
        return procurementAPI.get("DeliveryUnitItemCart/GetAllDeliveryUnitItemCarts");
    },
    GetDeliveryUnitItemCartByDU(context, data){
        return procurementAPI.get(`DeliveryUnitItemCart/DeliveryUnit/${data}`);
    },
    GetSingleDeliveryUnitItemCart(context, data){
        return procurementAPI.get(`DeliveryUnitItemCart/${data}`);
    },
    DeleteDeliveryUnitItemCart(context, data){
        return procurementAPI.delete(`DeliveryUnitItemCart/${data}`);
    },
    CreateDeliveryUnitItemCart(context, data){
        return procurementAPI.post(`DeliveryUnitItemCart/Add`, data);
    },
    ClearDeliveryUnitItemCart(context, data){
        return procurementAPI.post(`DeliveryUnitItemCart/Clear`, data);
    },
}